export default __webpack_public_path__ + "static/media/visual-studio-code.3001bc63.svg";